import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {
    pacienteIncluindoNome: ""
};

const getters = {
    pacienteIncluindoNome(state) {
        return state.pacienteIncluindoNome;
    }
};

const mutations = {
    updatePacienteIncluindoNome(store, pacienteIncluindoNome) {
        store.pacienteIncluindoNome = pacienteIncluindoNome;
    }
};

const actions = {
    atualizarPacienteIncluindoNome(context, pacienteIncluindoNome) {
        context.commit("updatePacienteIncluindoNome", pacienteIncluindoNome);
    },
    getPacientes(context, dados) {
        if ((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados = {
                pagina: 1,
                quantidadePorPagina: 25
            };
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacientesBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacientesCpfBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listaCpfBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPaciente(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/obter", { ID_PACIENTE: idPaciente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacienteSimples(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/obterSimples", { ID_PACIENTE: idPaciente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacientesCPF(context, cpf) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarCPF", { CPF: cpf }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacientesTelefone(context, telefone) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarTelefone", { TELEFONE: telefone }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacienteFoto(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/obterFoto", { ID_PACIENTE: idPaciente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacientesFotos(context, idsPacientes) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/obterFotos", idsPacientes).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deletePaciente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/excluir", { ID_PACIENTE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postPaciente(context, paciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/salvar", paciente).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postPacienteSimples(context, paciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/salvarSimples", paciente).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getVerificaExisteRG(context, RG) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/verificaExisteRG", { RG: RG }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacienteAtendimentosQuantidade(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/pacienteAtendimentosQuantidade", { ID_PACIENTE: idPaciente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    updatePaciente(context, paciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/salvar", paciente).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async buscarAprovacoesImagens(context, idPaciente) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para consultar os dados do atendimento."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("pacientes/access/buscarAprovacoesImagens", { ID_PACIENTE: idPaciente }, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Resposta inválida ao consultar os dados do atendimento."); }
        return data;
    },
    excluirAprovacaoImagem(context, idAprovacaoImagem) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/excluirAprovacaoImagem", {ID_PACIENTE_IMAGEM_APROVACAO: idAprovacaoImagem}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    excluirImagem(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/excluirImagem", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvarAprovacaoImagem(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/salvarAprovacaoImagem", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    indicarAssociacaoDocumento(context, idDocumento) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/indicarAssociacaoDocumento", {ID_PACIENTE_DOCUMENTO: idDocumento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    temEspacoArmazenamento() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("pacientesImagens/access/temEspacoArmazenamento").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarImportador(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientesImagens/access/salvarImportador", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPacientesOcorrencias(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarPacienteOcorrencias", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAvisosPaciente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarAvisosPaciente", {ID_PACIENTE: dados.ID_PACIENTE, ID_CONVENIO: dados.ID_CONVENIO, ID_AGENDA: dados.ID_AGENDA}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getProcedimentosSolicitadosPaciente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarProcedimentosSolicitadosPaciente", {ID_PACIENTE: dados.ID_PACIENTE}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPacientesPorId(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarPacientesPorId", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPacientesPorCpf(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/listarPacientesPorCpf", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getVerificaExisteCPF(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pacientes/access/verificaExisteCPF", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};